.infoSection {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacingSm);
}

.gray {
  color: var(--paletteBlue2);
}

.title {
  display: flex;
  column-gap: var(--spacingMd);
  align-items: center;
}
